exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-60818b56]{overflow:auto}.pagination[data-v-60818b56]{display:inline-block!important}", ""]);

// exports
